import _classCallCheck from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/classCallCheck.js";
import _createClass from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/createClass.js";
import _inherits from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/inherits.js";
import _possibleConstructorReturn from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/possibleConstructorReturn.js";
import _getPrototypeOf from "/home/runner/work/bike-tour-blog/bike-tour-blog/node_modules/@babel/runtime/helpers/esm/getPrototypeOf.js";

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import { isGenerator, isInlineData, isNamedData, isSphereGenerator, isUrlData } from '../../data';
import { contains, isEmpty, omit } from '../../util';
import { DataFlowNode } from './dataflow';
export var SourceNode = /*#__PURE__*/function (_DataFlowNode) {
  _inherits(SourceNode, _DataFlowNode);

  var _super = _createSuper(SourceNode);

  function SourceNode(data) {
    var _this;

    _classCallCheck(this, SourceNode);

    _this = _super.call(this, null); // source cannot have parent

    data !== null && data !== void 0 ? data : data = {
      name: 'source'
    };
    var format;

    if (!isGenerator(data)) {
      format = data.format ? Object.assign({}, omit(data.format, ['parse'])) : {};
    }

    if (isInlineData(data)) {
      _this._data = {
        values: data.values
      };
    } else if (isUrlData(data)) {
      _this._data = {
        url: data.url
      };

      if (!format.type) {
        // Extract extension from URL using snippet from
        // http://stackoverflow.com/questions/680929/how-to-extract-extension-from-filename-string-in-javascript
        var defaultExtension = /(?:\.([^.]+))?$/.exec(data.url)[1];

        if (!contains(['json', 'csv', 'tsv', 'dsv', 'topojson'], defaultExtension)) {
          defaultExtension = 'json';
        } // defaultExtension has type string but we ensure that it is DataFormatType above


        format.type = defaultExtension;
      }
    } else if (isSphereGenerator(data)) {
      // hardwire GeoJSON sphere data into output specification
      _this._data = {
        values: [{
          type: 'Sphere'
        }]
      };
    } else if (isNamedData(data) || isGenerator(data)) {
      _this._data = {};
    } // set flag to check if generator


    _this._generator = isGenerator(data); // any dataset can be named

    if (data.name) {
      _this._name = data.name;
    }

    if (format && !isEmpty(format)) {
      _this._data.format = format;
    }

    return _this;
  }

  _createClass(SourceNode, [{
    key: "dependentFields",
    value: function dependentFields() {
      return new Set();
    }
  }, {
    key: "producedFields",
    value: function producedFields() {
      return undefined; // we don't know what this source produces
    }
  }, {
    key: "data",
    get: function get() {
      return this._data;
    }
  }, {
    key: "hasName",
    value: function hasName() {
      return !!this._name;
    }
  }, {
    key: "isGenerator",
    get: function get() {
      return this._generator;
    }
  }, {
    key: "dataName",
    get: function get() {
      return this._name;
    },
    set: function set(name) {
      this._name = name;
    }
  }, {
    key: "parent",
    set: function set(parent) {
      throw new Error('Source nodes have to be roots.');
    }
  }, {
    key: "remove",
    value: function remove() {
      throw new Error('Source nodes are roots and cannot be removed.');
    }
  }, {
    key: "hash",
    value: function hash() {
      throw new Error('Cannot hash sources');
    }
  }, {
    key: "assemble",
    value: function assemble() {
      return Object.assign(Object.assign({
        name: this._name
      }, this._data), {
        transform: []
      });
    }
  }]);

  return SourceNode;
}(DataFlowNode);